import React from 'react';
import { Icon, WysiwygField } from '@uncinc/uncinc-react-kitchen-sink';

import Card from '../../../../components/Card';

import './style.scss';

interface TaxonomyDepartmentCardProps {
  title: string;
  image: React.ReactNode;
  subtitle?: string | null;
  link: string;
}

const TaxonomyDepartmentCard: React.FC<TaxonomyDepartmentCardProps> = ({
  title,
  image,
  subtitle,
  link,
}) => (
  <Card className="TaxonomyDepartmentCard" {...link && { withLink: true }}>
    <Card.Link href={link}>
      <Card.Image
        image={image}
      />
      <div className="Card__content__text">
        <div className="Card__content__text-wrapper">
          <Card.Title title={title} />

          <Card.Subtitle
            subtitle={(
              <WysiwygField html={subtitle} />
            )}
          />
        </div>
        <Icon className="Card__icon" name="keyboard_arrow_right" flair="outlined" />
      </div>
    </Card.Link>
  </Card>
);

export default TaxonomyDepartmentCard;
